import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { useSelectedCompanyStore } from '../stores/selectedCompany.store';
import {
  useListArchivedDocuments,
  useGetDocumentPresignedUrl,
} from '../services/documents.service';
import { ArchivedDocumentsTable } from '../components/documents/ArchivedDocumentsTable';

export const ArchivedDocumentsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedCompanyId = useSelectedCompanyStore((state) => state.selectedCompanyId);

  const { data, isLoading } = useListArchivedDocuments(selectedCompanyId ?? '');
  const getPresignedUrlMutation = useGetDocumentPresignedUrl(selectedCompanyId ?? '');

  const handleOpenDocument = async (nodeId: string) => {
    try {
      const result = await getPresignedUrlMutation.mutateAsync(nodeId);
      window.open(result.url, '_blank');
    } catch (error) {
      console.error('Error opening document:', error);
    }
  };

  const handleNavigateToFolder = (folderId: string) => {
    navigate(`/documents/${folderId}`);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <button
        onClick={() => navigate('/documents')}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft size={20} weight="regular" />
        {t('documents.back_to_documents')}
      </button>

      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        {t('documents.archived_page.title')}
        <span className="ml-2 text-base font-normal text-gray-500">
          ({data?.documents.length ?? 0})
        </span>
      </h1>

      <ArchivedDocumentsTable
        documents={data?.documents ?? []}
        isLoading={isLoading}
        onOpenDocument={handleOpenDocument}
        onNavigateToFolder={handleNavigateToFolder}
      />
    </div>
  );
};
